<template>
  <div class="wrapper">
    <ux-img
      :src="logo"
      alt="logo de la marque"
      center
    ></ux-img>

    <section>
      <SearchComponent></SearchComponent>
      <ResultsComponent></ResultsComponent>
    </section>

    <FooterComponent></FooterComponent>
  </div>
</template>

<script lang="ts">
import SearchComponent from './SearchComponent.vue'
import ResultsComponent from './ResultsComponent.vue'
import FooterComponent from './FooterComponent.vue'
import Logo from '../assets/images/logo-surav.png'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    SearchComponent,
    ResultsComponent,
    FooterComponent,
  },
  data() {
    const logo = Logo
    return {
      logo,
    }
  },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  width: 85%;
  margin: auto;
}

section {
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
